import { createFileRoute } from '@tanstack/react-router'

import { CustomerList } from '@/features/customers/customer-list'
import { customerListSearchSchema } from '@/features/customers/search'

export const Route = createFileRoute('/_app/customers/')({
  validateSearch: (search) => customerListSearchSchema.parse(search),
  component: CustomerList,
})
